import { Injectable } from '@angular/core';
import { EncryptService } from './encrypt/encrypt.service';
import { AuthenticationService } from './authentication/authentication.service';


@Injectable({
  providedIn: 'root'
})
export class InitAppService {

  constructor(
    private encryptService: EncryptService,
    private authenticationService: AuthenticationService,
  ) { }

  Init() {
    return new Promise<void>((resolve, reject) => {
      this.authenticationService.pair()
        .then(
          (resp) => {
            this.encryptService.generateKeys(resp);
            resolve();
          }
        )
      ;
    });
  }

}
